import { createAction, createReducer } from 'deox';
import { resetApplication } from './resetApplication';

export interface MagicLink {
  magicLinkId: string;
  status: 'AUTH_STARTED' | 'LINK_ACCEPTED';
  result?: MagicLinkResult;
}
export interface MagicLinkResult {
  phoneNumber: string;
  carrier: string;
  lineType: string;
  countryCode: string;
  phoneMatch: string;
  ipAddressMatch: boolean;
}

export const setMagicLink = createAction(
  'SET_MAGIC_LINK',
  resolve => (magicLink: MagicLink) => resolve(magicLink),
);

export const setMagicLinkResult = createAction(
  'SET_MAGIC_LINK_RESULT',
  resolve => (result: MagicLinkResult) => resolve(result),
);

export const defaultState = null as MagicLink | null;

export const magicLinkReducer = createReducer(defaultState, handleAction => [
  handleAction(setMagicLink, (_state, { payload: magicLink }) => {
    return magicLink;
  }),
  handleAction(setMagicLinkResult, (state, { payload: result }) => {
    if (state === null) {
      // magic link ID must have existed in order for it to be verified.
      throw new Error('Magic link should not be null at this point');
    }
    return {
      ...state,
      result: result,
    } as MagicLink;
  }),
  handleAction(resetApplication, () => defaultState),
]);

export interface MountedState {
  magicLink: ReturnType<typeof magicLinkReducer>;
}

export const selectMagicLink = (state: MountedState) => state.magicLink;

export default magicLinkReducer;
